import axios from 'axios'
import { removeLocalStorage, toastMessage, getLocalStorage, setLocalStorage } from './utils'
import router from '@/router'

import {
  getTokenRefreshStatus,
  setTokenRefreshStatus,
  addToTokenRefreshQueue,
  executeTokenRefreshQueue
} from './authService'

axios.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8'

axios.defaults.timeout = 20000

const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_URL
})

const getToken = () => getLocalStorage('token') ? `Bearer ${getLocalStorage('token')}` : ''

const httpCode = {
  400: '请求参数错误',
  401: '权限不足',
  403: '服务器拒绝本次访问',
  404: '请求资源未找到',
  408: '请求超时',
  500: '内部服务器错误',
  501: '服务器不支持该请求中使用的方法',
  502: '网关错误',
  503: '服务不可用',
  504: '网关超时',
  505: 'HTTP版本不受支持'
}

service.interceptors.request.use(
  config => {
    const auth = getToken()
    config.headers = {
      Authorization: auth,
      ...config.headers
    }
    return config
  },

  error => {
    // do something with request error
    console.error(error) // for debug
    return Promise.reject(error)
  }
)

service.interceptors.response.use(
  response => {
    const res = response.data
    const status = res.status
    if (status !== 0) {
      toastMessage(res.message)
      return Promise.reject(res.message)
    }
    return res
  },
  async error => {
    const res = error.response
    const code = res.status
    const msg = res.data.Message
    const oldRefreshToken = getLocalStorage('refreshToken')
    if (oldRefreshToken && (code === 401 || code === 403)) {
      if (!getTokenRefreshStatus()) {
        setTokenRefreshStatus(true)
        try {
          const refreshStr = process.env.VUE_APP_REFRESH_TOKEN
          const { accessToken, refreshToken } = await fetch(refreshStr + oldRefreshToken, {}, 'POST')
          if (accessToken) {
            setLocalStorage('token', accessToken)
            setLocalStorage('refreshToken', refreshToken)
            // 执行队列中的请求
            executeTokenRefreshQueue(accessToken)
            // 重试当前请求
            error.config.headers.Authorization = `Bearer ${accessToken}`
            return service(error.config)
          } else {
            removeLocalStorage('token')
            removeLocalStorage('userInfo')
            router.replace('/login')
            toastMessage('登录已过期，请重新登录')
          }
        } catch (refreshError) {
          removeLocalStorage('token')
          removeLocalStorage('userInfo')
          router.replace('/login')
          toastMessage('登录已过期，请重新登录')
        }
      } else {
        // 将请求加入队列
        return new Promise(resolve => {
          addToTokenRefreshQueue((token) => {
            error.config.headers.Authorization = `Bearer ${token}`
            resolve(service(error.config))
          })
        })
      }
    } else {
      toastMessage(httpCode[code])
      return Promise.reject(msg)
    }
  }
)

export const fetch = (url, data = {}, method = 'get') => {
  return new Promise((resolve, reject) => {
    service({
      url,
      data: ['post', 'delete'].includes(method) ? data : {},
      params: ['post', 'delete'].includes(method) ? {} : data,
      method
    }).then(res => resolve(res.data || res)).catch(err => reject(err))
  })
}
